import {
  Box,
  Card,
  CardContent,
  FormControlLabel,
  Switch,
  Stack,
} from '@mui/material';

import { useState } from 'react';
import CapacityStatCard from '../../../dashboard/CapacityStat';

const FormLatogatottsag = () => {
  const [compareYears, setCompareYears] = useState(false);

  return (
    <Box sx={{ p: 2 }}>
      <Card sx={{ mb: 2, borderRadius: 3 }}>
        <CardContent>
          <FormControlLabel
            control={
              <Switch
                checked={compareYears}
                onChange={(e) => setCompareYears(e.target.checked)}
              />
            }
            label='Év összehasonlítás'
          />
        </CardContent>
      </Card>

      <Stack spacing={2}>
        {compareYears ? (
          <>
            <CapacityStatCard tanev='2025/2026' oktatoSelect={false} />
            <CapacityStatCard tanev='2024/2025' oktatoSelect={false} />
          </>
        ) : (
          <CapacityStatCard tanev='2025/2026' oktatoSelect={true} />
        )}
      </Stack>
    </Box>
  );
};

export default FormLatogatottsag;
